import React, { Component } from 'react';
import './VendorsInvoicesTable.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import { toUpperFirstLetter } from 'services/utils/text-util';
import DocumentLink from 'components/shared/document/DocumentLink';
import Button from 'components/shared/button/Button';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import { connect } from 'react-redux';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import {
  searchTextSelector,
  vendorsInvoicesPaginationInfoSelector,
  vendorsInvoicesSelector,
  searchFiltersSelector,
} from 'components/admin/contractors-invoices/store/selectors';
import { getCurrentUser } from 'selectors/authentication';
import Date from 'components/shared/text/Date';
import Number from 'components/shared/text/Number';
import {
  changeVendorInvoicesPageRequest,
  getVendorsInvoices,
  markVendorInvoiceAsPaid,
  changeSearchFilterValue,
  initSearchFilters,
} from 'components/admin/contractors-invoices/store/actions';
import { InvoiceStatusKeys } from 'domain/invoice';
import Input from 'components/shared/input/Input';

class VendorsInvoicesTable extends Component {
  componentDidMount() {
    this.props.dispatch(getVendorsInvoices());
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  handleMarkAsPaid = (invoiceId) => {
    this.props.dispatch(markVendorInvoiceAsPaid(invoiceId));
  };

  handlePageChange = (page) => {
    this.props.dispatch(
      changeVendorInvoicesPageRequest(
        page,
        this.props.searchText,
        this.props.searchFilters
      )
    );
  };

  mapInvoices = (invoices) => {
    return invoices.map((invoice) => {
      return [
        invoice.work_order_number,
        invoice.task_number,
        invoice.work_order_job !== null ? invoice.work_order_job : 'N/A',
        invoice.client_name,
        invoice.vendor_name,
        toUpperFirstLetter(invoice.status),
        <Date value={invoice.due_date} format="LL" />,
        <Number value={invoice.cost} format="$0,0.[00]" />,
        <DocumentLink showIcon={false} url={invoice.document.document.url} />,
        invoice.status !== InvoiceStatusKeys.PAID ? (
          <Button
            className="button-blue-grey"
            label="Mark as Paid"
            onClick={() => this.handleMarkAsPaid(invoice.id)}
          />
        ) : (
          ''
        ),
      ];
    });
  };

  handleSearchFiltersValueChange = (attribute, value) => {
    this.props.dispatch(changeSearchFilterValue(attribute, value));
  };

  handleClearFilters = () => {
    this.props.dispatch(initSearchFilters());
    this.props.dispatch(
      changeVendorInvoicesPageRequest(1, this.props.searchText)
    );
  };

  render() {
    const headers = [
      'WO #',
      'TASK #',
      'JOB #',
      'CLIENT NAME',
      'VENDOR NAME',
      'STATUS',
      'DUE DATE',
      'AMOUNT',
      'DOC LINK',
      '', // button
    ];
    return (
      <div className="vendors-invoices-table">
        <div className="search-filters">
          <Input
            type="number"
            placeholder="WO #"
            value={this.props.searchFilters['by_wo_number']}
            onChange={(value) =>
              this.handleSearchFiltersValueChange('by_wo_number', value)
            }
          />
          <Input
            placeholder="Vendor Name"
            value={this.props.searchFilters['by_vendor_name']}
            onChange={(value) =>
              this.handleSearchFiltersValueChange('by_vendor_name', value)
            }
          />
          <Input
            type="number"
            placeholder="Min. Amount"
            value={this.props.searchFilters['by_min_cost']}
            onChange={(value) =>
              this.handleSearchFiltersValueChange('by_min_cost', value)
            }
          />
          <Input
            type="number"
            placeholder="Max. Amount"
            value={this.props.searchFilters['by_max_cost']}
            onChange={(value) =>
              this.handleSearchFiltersValueChange('by_max_cost', value)
            }
          />
          <Button
            className="button-orange"
            label="Filter"
            onClick={() => this.handlePageChange(1)}
          />
          <Button
            className="button-gray"
            label="Clear"
            onClick={this.handleClearFilters}
          />
        </div>

        <SimpleTable
          headers={headers}
          rows={this.mapInvoices(this.props.vendorInvoices)}
          emptyMessage="No Vendor Invoices"
        />

        {this.props.vendorInvoicesPaginationInfo !== null && (
          <div className="pagination-container">
            <SimplePagination
              currentPage={this.props.vendorInvoicesPaginationInfo.currentPage}
              pageSize={this.props.vendorInvoicesPaginationInfo.pageSize}
              total={this.props.vendorInvoicesPaginationInfo.total}
              onPageChange={(page) => this.handlePageChange(page)}
            />
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    searchText: searchTextSelector(state),
    vendorInvoices: vendorsInvoicesSelector(state),
    vendorInvoicesPaginationInfo: vendorsInvoicesPaginationInfoSelector(state),
    searchFilters: searchFiltersSelector(state),
  };
})(VendorsInvoicesTable);



// WEBPACK FOOTER //
// ./src/components/admin/contractors-invoices/VendorsInvoicesTable.js